export default {"src":"/_next/static/media/feature-image-04.4ecdcf7a.svg","height":389,"width":663,"blurWidth":0,"blurHeight":0};